import styled, { css } from 'styled-components';
import createComponentFromTagProp from 'react-create-component-from-tag-prop';
import PropTypes from 'prop-types';
import { spaceOptions, spaceProps } from './utils';
// import { rem } from 'polished/src/helpers/rem';

const commonOptions = css`
  ${spaceOptions} ${props =>
      props.semiBold &&
      css`
        font-weight: 600;
      `} ${props =>
      props.bold &&
      css`
        font-weight: 700;
      `} ${props =>
      props.center &&
      css`
        text-align: center;
      `} ${props =>
      props.secondaryDark &&
      css`
        color: ${props.theme.secondaryDark};
      `} ${props =>
      props.secondary &&
      css`
        color: ${props.theme.secondary};
      `} ${props =>
      props.muted &&
      css`
        color: ${props.theme.muted};
      `} ${props =>
      props.primary &&
      css`
        color: ${props.theme.primary};
      `} ${props =>
      props.dark &&
      css`
        color: ${props.theme.dark};
      `} a {
    color: ${props => props.theme.bodyFont};
    text-decoration: none;
    &:hover,
    &:active {
      color: ${props => props.theme.primary};
    }
  }
`;

const propsToOmit = [
  'center',
  'semiBold',
  'bold',
  'primary',
  'secondary',
  'secondaryDark',
  'muted',
  'dark',
  ...spaceProps
];

export const HeadingOne = styled(
  createComponentFromTagProp({
    tag: 'h1',
    propsToOmit
  })
)`
  font-size: 52px;
  line-height: 60px;
  font-family: '${props => props.theme.fontTitles}';
  font-weight: normal;
  margin-top: 0;
  margin-bottom: 30px;
  ${commonOptions}
  @media (max-width: ${props => props.theme.breakpoints.sm}rem) {
    font-size: 44px;
    line-height: 50px;
  }
`;
HeadingOne.displayName = 'HeadingOne';

export const HeadingTwo = styled(
  createComponentFromTagProp({
    tag: 'h2',
    propsToOmit
  })
)`
  font-size: 42px;
  line-height: 50px;
  font-family: '${props => props.theme.fontTitles}';
  font-weight: normal;
  margin: 0;
  ${commonOptions}
  @media (max-width: ${props => props.theme.breakpoints.sm}rem) {
    font-size: 36px;
    line-height: 40px;
  }
`;
HeadingTwo.displayName = 'HeadingTwo';

export const HeadingThree = styled(
  createComponentFromTagProp({
    tag: 'h3',
    propsToOmit
  })
)`
  font-size: 32px;
  line-height: 40px;
  font-family: '${props => props.theme.fontDefault}';
  font-weight: normal;
  margin: 0;
  ${commonOptions}
`;
HeadingThree.displayName = 'HeadingThree';

export const HeadingFour = styled(
  createComponentFromTagProp({
    tag: 'h4',
    propsToOmit
  })
)`
  font-size: 26px;
  line-height: 34px;
  font-family: '${props => props.theme.fontDefault}';
  font-weight: normal;
  margin: 0;
  ${commonOptions}
`;
HeadingFour.displayName = 'HeadingFour';

export const HeadingFive = styled(
  createComponentFromTagProp({
    tag: 'h5',
    propsToOmit
  })
)`
  font-size: 20px;
  line-height: 26px;
  font-family: '${props => props.theme.fontDefault}';
  font-weight: normal;
  margin: 0;
  ${commonOptions}
`;
HeadingFive.displayName = 'HeadingFive';

export const HeadingSix = styled(
  createComponentFromTagProp({
    tag: 'h6',
    propsToOmit
  })
)`
  font-size: 14px;
  line-height: 22px;
  font-family: '${props => props.theme.fontDefault}';
  font-weight: normal;
  margin: 0;
  ${commonOptions}
  text-transform: uppercase;
`;
HeadingFive.displayName = 'HeadingSix';

export const ParagraphTitle = styled(
  createComponentFromTagProp({
    tag: 'p',
    propsToOmit
  })
)`
  font-size: 17px;
  line-height: 24px;
  font-family: '${props => props.theme.fontDefault}';
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 14px;
  ${commonOptions}
`;
ParagraphTitle.displayName = 'ParagraphTitle';

export const Paragraph = styled(
  createComponentFromTagProp({
    tag: 'p',
    propsToOmit
  })
)`
  font-size: 16px;
  line-height: 26px;
  font-family: '${props => props.theme.fontDefault}';
  font-weight: normal;
  margin-top: 0;
  margin-bottom: 14px;
  ${commonOptions}
`;
Paragraph.displayName = 'Paragraph';

export const SubParagraph = styled(
  createComponentFromTagProp({
    tag: 'p',
    propsToOmit
  })
)`
  font-size: 16px;
  line-height: 26px;
  margin-top: 0;
  margin-bottom: 14px;
  ${commonOptions};
`;
SubParagraph.displayName = 'SubParagraph';

export const SmallText = styled(
  createComponentFromTagProp({
    tag: 'p',
    propsToOmit
  })
)`
  font-size: 14px;
  line-height: 20px;
  margin-top: 0;
  margin-bottom: 14px;
  ${commonOptions};
`;
SmallText.displayName = 'SmallText';

export const TinyText = styled(
  createComponentFromTagProp({
    tag: 'p',
    propsToOmit
  })
)`
  font-size: 12px;
  line-height: 18px;
  margin-top: 0;
  margin-bottom: 14x;
  ${commonOptions};
`;
TinyText.displayName = 'TinyText';

export const FooterText = styled(
  createComponentFromTagProp({
    tag: 'p',
    propsToOmit
  })
)`
  font-size: 12px;
  line-height: 18px;
  font-family: '${props => props.theme.fontDefault}';
`;
FooterText.displayName = 'FooterText';

export const HorizontalRule = styled.hr`
  width: ${props => (props.width ? props.width : '100%')};
  height: ${props => (props.height ? props.height : '3px')};
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : props.theme.primary};
  border: none;
  margin-bottom: 15px;
  ${spaceOptions} ${props =>
      props.center &&
      css`
        text-align: center;
      `} ${props =>
      !props.center &&
      css`
        text-align: left;
        margin-left: 0;
      `};
`;
HorizontalRule.displayName = 'HorizontalRule';

const Types = ['primary', 'secondary'];
const getColorFromProps = props =>
  props.theme[Types.find(type => Object.keys(props).indexOf(type) > -1)] || props.theme.back;

export const Label = styled.span`
  background: ${props => props.theme.snow};
  font-family: '${props => props.theme.fontDefault}';
  font-size: ${props => props.fontSize || 14}px;
  display:  ${props => (props.ghost ? 'inline-block' : 'block')};
  text-transform: ${props => (props.ghost ? 'none' : 'uppercase')};
  font-weight: ${props => (props.ghost ? 400 : 600)};
  border: ${props => (props.ghost ? '1px solid #C6C6C7' : 0)};
  border-radius: ${props => (props.ghost ? '100px' : 0)};
  margin-right: ${props => (props.ghost ? '10px' : 0)};
  padding: ${props => (props.ghost ? '.5rem 1rem' : 0)};
  letter-spacing: ${props => (props.ghost ? 0 : '1px')};
  color: ${props => (props.ghost ? props.theme.bodyFont : getColorFromProps(props))};
  a {
    color: ${props => (props.ghost ? props.theme.bodyFont : getColorFromProps(props))};
    text-decoration: none;
    &:hover,
    &:active {
      opacity: .6;
    }
    &:visited {
      color: ${props => (props.ghost ? props.theme.bodyFont : getColorFromProps(props))};
    }
  }
  ${spaceOptions}
`;

Label.displayName = 'Label';
Label.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  ghost: PropTypes.bool
};
